import React from 'react'

import style from '@styles/TopBar.module.scss'

interface Props {
  title: string
}

const BasicTopBar = ({ title }: Props) => (
  <div className={style.container}>
    <p className={style.header}>{title}</p>
  </div>
)

export { BasicTopBar }
